module.exports = __webpack_public_path__ + "img/salk_institute.390a310d.jpg";